import { request, removeEmptyAttribute } from "../helpers/utility";

let instance = null;

export default class ConfigResources {
    constructor() {
        if (!instance) {
            this.url = 'admin/config-values';
            instance = this;
        }
        return instance;
    }

    get() {
        return request.GET(this.url)
    }

    get_by_name(name) {
        return request.GET(this.url + '?name=' + name)
    }

    update(config_id, body) {
        let put_body = { ...body };
        put_body = removeEmptyAttribute(put_body);
        return request.PUT(this.url + '/' + config_id, put_body)
    }

    create_or_update(body) {
        let post_body = { ...body };
        post_body = removeEmptyAttribute(post_body);
        return request.POST(this.url, post_body)
    }

    get_cw_teams() {
        return request.GET('config-values/cw-teams')
    }
}